export interface UnsubscribedEmailModel {
  id: number;
  domainType: string;
  email: string;
  typeId: number;
  typeName: string;
  activityId: number;
  activityName: string;
  reason: string;
  templateIdentifier?: string;
  htmlFile?: boolean;
  createdBy: string;
  createdDate: Date;
}
